<template>
    <div>
        <PullContainer ref="pullContainerRef" :pullDownLoading="true" :pullDownLabel="true" @pullDownLoadingSuccess="pullDownLoadingSuccess">
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                    </div>
                    <div class="mobile_container">
                        <ul class="list_wrap" v-infinite-scroll="onLoadList">
                            <li class="list_item" v-for="row in tableData">
                                <div class="list_item_content">
                                    <template v-if="tabActiveName == 'unRefund' || tabActiveName == 'badDebt'">
                                        <p>订单编号：<span class="link-label" @click="handleClickOrderDetail(row)">{{ row.order_num }}</span></p>
                                        <p>客户公司名称：<span class="link-label" v-if="tabActiveName == 'unRefund'" @click="handleClickCustomerDetail(customer_id, row.customer_name)">{{
                                            row.customer_name }}</span><span class="link-label" @click="
                                                    handleClickCustomerDetail(
                                                        row.customer_info && row.customer_info.id,
                                                        row.customer_info && row.customer_info.name
                                                    )
                                                    " v-else>{{ row.customer_info &&
                                                        row.customer_info.name }}</span></p>
                                    </template>
                                    <template v-else-if="
                                        tabActiveName == 'orderRefund' || (tabActiveName == 'receivableSummary' && customer_id)
                                    ">
                                        <p>回款编号：<span class="link-label" @click="handleClickReceivableDetail(row)">{{ row.receivable_no }}</span></p>
                                        <p>客户公司名称：<span class="link-label" @click="
                                            handleClickCustomerDetail(
                                                row.customer_info && row.customer_info.id,
                                                row.customer_name
                                            )
                                            ">{{ row.customer_name }}</span></p>
                                        <p>回款公司名称：{{ row.payment_company_name }}</p>
                                        <p>订单编号：<span class="link-label" @click="handleClickOrderDetail(row)">{{ row.order_num }}</span></p>
                                    </template>
                                    <template v-else-if="
                                        tabActiveName == 'purchase' || (tabActiveName == 'receivableSummary' && !customer_id)
                                    ">
                                        <p>应收编号：<span class="link-label">{{ row.receivable_no }}</span></p>
                                        <p>供应商名称：{{ row.supplier_name }}</p>
                                        <p>采购编号：<span class="link-label">{{ row.purchase_refund_no }}</span></p>
                                        <p>审批编号：<span class="link-label">{{ row.approval_id }}</span></p>

                                    </template>
                                    <div class="mobile_detail_head_user_wrap" v-if="tabActiveName != 'unRefund' && tabActiveName != 'badDebt'">
                                        申请人：
                                        <div class="mobile_detail_head_user" v-if="row.uid_info && row.uid_info.id" @click="handleClickUserInfo(row.uid_info)">
                                            <img :src="row.uid_info.avatar
                                                ? row.uid_info.avatar
                                                : defaultImg
                                                " alt="" />
                                            <span class="ellipsis">{{
                                                row.uid_info &&
                                                row.uid_info.name
                                            }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="list_item_amount">
                                    <template v-if="tabActiveName == 'badDebt' || tabActiveName == 'unRefund'">
                                        <div>
                                            <div class="list_item_amount_percent percent_bg1">
                                                订单总金额：¥{{ row.total_price }}
                                            </div>
                                        </div>
                                        <div>
                                            <div class="list_item_amount_percent percent_bg2">
                                                已回款总金额：¥{{ row.total_repay_price }}
                                            </div>
                                            <div class="list_item_amount_percent percent_bg4">
                                                未回款金额：¥{{ row.no_repay_price }}
                                            </div>
                                            <div class="list_item_amount_percent percent_bg3" v-if="tabActiveName == 'badDebt'">
                                                坏账金额：¥{{ row.bad_debt_amount }}
                                            </div>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <div class="list_item_amount_percent percent_bg1">
                                                待确认金额：¥{{ row.status == 1 ? row.receivable_amount : row.confirmed_amount }}
                                            </div>
                                        </div>
                                        <div>
                                            <div class="list_item_amount_percent percent_bg2">
                                                已确认金额：¥{{ row.confirmed_amount }}
                                            </div>
                                            <div class="list_item_amount_percent percent_bg4" v-if="
                                                (tabActiveName == 'receivableSummary' && customer_id) ||
                                                tabActiveName == 'orderRefund'
                                            ">
                                                已驳回金额：¥{{ row.rejected_amount }}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </PullContainer>
        <userDetailDialog v-if="userDetailPopupShow" :userDetailPopupShow.sync="userDetailPopupShow" :userId="userDetailId" />
    </div>
</template>
<script>
import {
    BadDebtCustomerDetail,
    UnpaidCustomerOrders,
    RepayCompanyDetail,
    PurchaseRefundDetailList,
    ReceivableOrderSummaryDetail,
    ReceivablePurchaseRefundSummaryDetail,
} from "@/api";
import { pagination } from "@/mixins";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
export default {
    name: "ReceivableStatisticsDetails",
    components: {
        PullContainer,
        ReturnNavBar,
        userDetailDialog
    },
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            tabActiveName: this.$route.query && this.$route.query.tabActiveName,
            customer_id: this.$route.query && this.$route.query.customer_id,
            payment_company_name: this.$route.query && this.$route.query.payment_company_name,
            supplier_name: this.$route.query && this.$route.query.supplier_name,
            // 详情
            loading: false,
            tableData: [],
            // 人员详细信息
            userDetailPopupShow: false,
            userDetailId: "",
        };
    },
    mixins: [pagination],
    created() {
        this.onSearch()
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onSearch();
            }
        },
        // 人员详细信息
        handleClickUserInfo(info) {
            this.userDetailId = info.id;
            this.userDetailPopupShow = true;
        },
        onSearch() {
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getMoreTypeData();
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getMoreTypeData();
            }
        },
        getMoreTypeData() {
            this.loading = true
            let params = {
                page: this.pagination.pageNum,
                pageSize: 10, // this.pagination.pageSize
            };
            if (this.tabActiveName == "badDebt" || this.tabActiveName == "unRefund") {
                params.customer_id = this.customer_id;
            } else if (this.tabActiveName == "orderRefund") {
                params.payment_company_name = this.payment_company_name;
            } else if (this.tabActiveName == "purchase") {
                params.supplier_name = this.supplier_name;
            }
            if (this.tabActiveName == "badDebt") {
                BadDebtCustomerDetail(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                });
            } else if (this.tabActiveName == "unRefund") {
                UnpaidCustomerOrders(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                });
            } else if (this.tabActiveName == "orderRefund") {
                RepayCompanyDetail(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                });
            } else if (this.tabActiveName == "purchase") {
                PurchaseRefundDetailList(params).then((res) => {
                    if (res.code === 200) {
                        const { data, total } = res.data;
                        this.tableData = this.tableData.concat(data);
                        this.pagination.total = total;
                        this.pagination.pageNum++;
                        this.loading = false;
                        if (this.pullDownLoading) {
                            this.pullDownLoading = false;
                            this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                        }
                    }
                });
            } else {
                // 应收汇总
                if (this.customer_id) {
                    ReceivableOrderSummaryDetail({ customer_id: this.customer_id }).then((res) => {
                        if (res.code === 200) {
                            this.tableData = res.data || [];
                            this.pagination.total = this.tableData.length;
                            this.pagination.pageNum++;
                            this.loading = false;
                            if (this.pullDownLoading) {
                                this.pullDownLoading = false;
                                this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                            }
                        }
                    });
                } else {
                    params.supplier_name = this.supplier_name;
                    ReceivablePurchaseRefundSummaryDetail(params).then((res) => {
                        if (res.code === 200) {
                            this.tableData = res.data || [];
                            this.pagination.total = this.tableData.length;
                            this.pagination.pageNum++;
                            this.loading = false;
                            if (this.pullDownLoading) {
                                this.pullDownLoading = false;
                                this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                            }
                        }
                    });
                }
            }
        },
        handleClickReceivableDetail(row) {
            this.$router.push({
                name: "ReceivableDetails",
                query: {
                    receivable_no: row.receivable_no
                },
            });
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
        // 订单详情
        handleClickOrderDetail(row) {
            this.$router.push({
                name: "OrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    order_id: row.order_num,
                    name: row.order_num,
                    query_type: "order_no",
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/finance_management.scss";

.mobile_container {
    width: 100%;
    padding: 10px 16px;
    box-sizing: border-box;
}
</style>
